<div class="row justify-content-center justify-content-xl-start align-items-stretch g-3">
  <div class="co col-md-6 col-xl-auto">
    <div class="custom-card">
      <div id="thaid-card" class=" p-4 rounded-4 text-white clearfix">
        <h5 class="">ตรวจสอบสิทธิด้วย</h5>
        <h4 class="fw-semibold text-truncate">ThaiD</h4>
        <h4 class="fw-semibold text-truncate">&nbsp;</h4>
        <button class="btn btn-custom card-button" (click)="authenThaiD()" type="button">
          เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="co col-md-6 col-xl-auto">
    <div class="custom-card">
      <div id="idcard-card" class=" p-4 rounded-4 text-white">
        <h5 class="">ตรวจสอบสิทธิด้วย</h5>
        <h4 class="fw-semibold text-truncate">บัตรประจำตัวประชาชน</h4>
        <h4 class="fw-semibold text-truncate">&nbsp;</h4>
        <!--          <h4 class="fw-semibold text-truncate">(Smart Card)</h4>-->
        <button class="btn btn-custom card-button" routerLink="idcard" type="button">
          เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="co col-md-6 col-xl-auto">
    <div class="custom-card">
      <div id="personal-id-card" class=" p-4  rounded-4 text-white">
        <h5 class="">ตรวจสอบสิทธิด้วย</h5>
        <h4 class="fw-semibold text-truncate">เลขประจำตัวประชาชน</h4>
        <h4 class="fw-semibold text-truncate">&nbsp;</h4>
        <button class="btn btn-custom card-button" routerLink="personal-id" type="button">
          เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
        </button>
      </div>
    </div>
  </div>
    <div class="co col-md-6 col-xl-auto">
      <div class="custom-card">
        <div id="name-card" class=" p-4  rounded-4 text-white">
          <h5 class="">ตรวจสอบสิทธิด้วย</h5>
          <h4 class="fw-semibold">ชื่อ-นามสกุล</h4>
          <h4 class="fw-semibold text-truncate">&nbsp;</h4>
          <button class="btn btn-custom card-button" (click)="searchByName()" type="button">
            เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
          </button>
        </div>
      </div>
    </div>
</div>
